import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";
import RuvnlSimulationIndex from "./SimulateProcurement/SimulationIndex";
import PowerIndex from "./PowerProcurement/PowerIndex";
import { useDispatch } from "react-redux";
import { getProcurementDemoSession } from "../../../Rest_api/DemoRestApi";
import { setOptimizerDemoDateRange } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerDate";
import { setOptimizerDemoSessionToken } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSessionToken";
import { setOptimizerDemoSession } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSession";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();

  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getProcurementDemoSession();
      if (data) {
        dispatch(
          setOptimizerDemoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          }),
        );
        dispatch(setOptimizerDemoSession(data.session));
        dispatch(setOptimizerDemoSessionToken(data.session_token));
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);

  const renderPage = () => {
    switch (currentPage) {
      case "power":
        return <PowerIndex />;
      case "simulation":
        return <RuvnlSimulationIndex />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
